const STORAGE_KEY = 'connecto_utm_attribution_v1';
const UTM_FIELDS = ['utm_source', 'utm_medium', 'utm_campaign'];
const MAX_VALUE_LENGTH = 500;

const emptyAttribution = () => Object.fromEntries(
  UTM_FIELDS.map((field) => [field, null])
);

const getCurrentSearch = () => (
  typeof window === 'undefined' ? '' : window.location.search
);

const hasAttribution = (attribution) => (
  UTM_FIELDS.some((field) => Boolean(attribution[field]))
);

export const parseUtmParameters = (search = '') => {
  const params = new URLSearchParams(search);
  const attribution = emptyAttribution();

  UTM_FIELDS.forEach((field) => {
    const value = params.get(field)?.trim();
    if (value) attribution[field] = value.slice(0, MAX_VALUE_LENGTH);
  });

  return attribution;
};

const readStoredAttribution = () => {
  if (typeof window === 'undefined') return emptyAttribution();

  try {
    const stored = JSON.parse(window.sessionStorage.getItem(STORAGE_KEY));
    if (!stored || typeof stored !== 'object') return emptyAttribution();

    return Object.fromEntries(UTM_FIELDS.map((field) => {
      const value = typeof stored[field] === 'string' ? stored[field].trim() : '';
      return [field, value ? value.slice(0, MAX_VALUE_LENGTH) : null];
    }));
  } catch {
    return emptyAttribution();
  }
};

/**
 * Saves the latest campaign found in the URL for the current browser tab.
 * Values are never hard-coded: the URL controls google/facebook/campaign names.
 */
export const captureUtmAttribution = (search = getCurrentSearch()) => {
  const attribution = parseUtmParameters(search);
  if (!hasAttribution(attribution)) return readStoredAttribution();

  if (typeof window !== 'undefined') {
    try {
      window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(attribution));
    } catch {
      // The current URL values can still be sent when storage is unavailable.
    }
  }

  return attribution;
};

export const getUtmAttribution = () => captureUtmAttribution();
